import { Button, IconDownload, Search, Select, Table } from '@veneer/core';
import React, { useState, useEffect } from 'react';
import { filterSort } from '../../../helpers/helperFunctions';
import { currencyFormat } from '../../../common/js/utils/numberFormat';
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';

const BonusPayment = (props) => {
    const columnsDefaultOrder = [
        'idCustomer',
        'customerName',
        'idEndUser',
        'endUserName',
        'lastConfirmationFormatted',
        'toBePaid',
        'lastActiveMonthFormatted',
        'lastConfirmationExpectedFormatted',
        'cnOnExpectedConfirmationFormatted',
        'cnOnLastPublicationFormatted',
        'cnOnHoldFormatted',
        'cnReleasedFormatted'
    ];
    const [customerNameFileterVal, setCustomerNameFilterVal] = useState();
    const [endUserNameFilterVal, setEndUserNameFilterVal] = useState();
    const [toBePaidFilterVal, setToBePaidFilterVal] = useState();
    const [data, setData] = useState([]);
    const [loadingData, setLoadingData] = useState(true);
    const [sortBy, setSortBy] = useState('customerName');
    const [sortType, setSortType] = useState('ascending');
    const connectApi = new ConnectAPI();
    const [downloading, setDownloading] = useState(false);
    const [columnsOrder, setColumnsOrder] = useState(columnsDefaultOrder);
    const {t} = useTranslation();

    useEffect(() => {
        //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate
        setLoadingData(true);

        const handleResponse = (status, data) => {

            const nullDate = '1900-01-01T00:00:00';

            data.forEach(x => {
                x.lastConfirmationFormatted = x.lastConfirmation != nullDate ? moment(x.lastConfirmation).format("MMM/YYYY") : '';
                x.lastActiveMonthFormatted = x.lastActiveMonth != nullDate ? moment(x.lastActiveMonth).format("MMM/YYYY") : '';
                x.lastConfirmationExpectedFormatted = x.lastConfirmationExpected != nullDate ? moment(x.lastConfirmationExpected).format("MMM/YYYY") : '';
                x.cnOnExpectedConfirmationFormatted = currencyFormat(x.cnOnExpectedConfirmation, "USD");
                x.cnOnLastPublicationFormatted = currencyFormat(x.cnOnLastPublication, "USD");
                x.cnOnHoldFormatted = currencyFormat(x.cnOnHold, "USD");
                x.cnReleasedFormatted = currencyFormat(x.cnReleased, "USD");
            });
            setData(data);
            setLoadingData(false);
        }

        connectApi.get(
            "api/Channels/BonusPaymentReport",
            null,
            handleResponse
        ).catch((error) => {
            setLoadingData(false);
            Swal.fire(
                "Error " + error.response.status,
                error.response.data,
                "error"
            );
        });

    }, []);

    const filteredData = filterSort(
        data,
        {
            customerName: customerNameFileterVal,
            endUserName: endUserNameFilterVal,
            toBePaid: toBePaidFilterVal
        },
        sortBy,
        sortType
    );

    const handleSort = (_, { id, type }) => {
        setSortBy(id);
        setSortType(type);
    }

    const downloadReport = () => {
        setDownloading(true);

        const reportData = data.map(x => {
            return {
                idCustomer: x.idCustomer,
                customerName: x.customerName,
                idEndUser: x.idEndUser,
                endUserName: x.endUserName,
                lastConfirmation: moment(x.lastConfirmation).format("DD/MM/YYYY"),
                toBePaid: x.toBePaid,
                lastActiveMonth: moment(x.lastActiveMonth).format("DD/MM/YYYY"),
                lastConfirmationExpected: moment(x.lastConfirmationExpected).format("DD/MM/YYYY"),
                cnOnExpectedConfirmation: x.cnOnExpectedConfirmation,
                cnOnLastPublication: x.cnOnLastPublication,
                cnOnHold: x.cnOnHold,
                cnReleased: x.cnReleased
            };
        });

        const ws = XLSX.utils.json_to_sheet(reportData);
        const wb = XLSX.utils.book_new();

        const now = moment(new Date()).format("YYYYMMDDHHmm");

        const fileName = `Bonus Payment Report - ${now} - .xlsx`;

        XLSX.utils.book_append_sheet(wb, ws, "Report");

        XLSX.writeFile(wb, fileName);


        setDownloading(false);
    }

    return (
        <div style={{ marginTop: '15px' }}>
            <Table
                columns={[
                    {
                        id: 'idCustomer',
                        label: t('customerId'),
                    },
                    {
                        id: 'customerName',
                        label: t('customerName'),
                        filter: (
                            <Search
                                value={customerNameFileterVal}
                                onChange={setCustomerNameFilterVal}
                            />
                        )
                    },
                    {
                        id: 'idEndUser',
                        label: t('endUserId')
                    },
                    {
                        id: 'endUserName',
                        label: t('endUserName'),
                        filter: (
                            <Search
                                value={endUserNameFilterVal}
                                onChange={setEndUserNameFilterVal}
                            />
                        )
                    },
                    {
                        id: 'lastConfirmationFormatted',
                        label: t('lastConfirmation')
                    },
                    {
                        id: 'toBePaid',
                        label: t('toBePaid'),
                        filter: (
                            <Select
                                options={[{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }]}
                                value={toBePaidFilterVal}
                                onClear={() => setToBePaidFilterVal([])}
                                onChange={(e) => setToBePaidFilterVal([e.value])}
                                clearIcon
                            />
                        )
                    },
                    {
                        id: 'lastActiveMonthFormatted',
                        label: t('lastActiveMonth')
                    },
                    {
                        id: 'lastConfirmationExpectedFormatted',
                        label: t('lastConfirmationExpected')
                    },
                    {
                        id: 'cnOnExpectedConfirmationFormatted',
                        label: t('cnOnExpectedConfirmation')
                    },
                    {
                        id: 'cnOnLastPublicationFormatted',
                        label: t('cnOnLastPublication')
                    },
                    {
                        id: 'cnOnHoldFormatted',
                        label: t('cnOnHold')
                    },
                    {
                        id: 'cnReleasedFormatted',
                        label: t('cnReleased')
                    }
                ]}
                data={filteredData}
                showClearAllFilters={true}
                showFilters={true}
                loading={loadingData}
                loadingDataLength={50}
                behavior={{ type: 'singlePage', offset: { top: 0, bottom: 85 } }}
                preferences={{
                    width: [
                        {
                            columnId: 'idCustomer', width: 100
                        },
                        {
                            columnId: 'customerName', width: 250
                        },
                        {
                            columnId: 'idEndUser', width: 100
                        },
                        {
                            columnId: 'endUserName', width: 250
                        },
                        {
                            columnId: 'lastConfirmationFormatted', width: 100
                        },
                        {
                            columnId: 'toBePaid', width: 120
                        },
                        {
                            columnId: 'lastActiveMonthFormatted', width: 100
                        },
                        {
                            columnId: 'lastConfirmationExpectedFormatted', width: 100
                        },
                        {
                            columnId: 'cnOnExpectedConfirmationFormatted', width: 100
                        },
                        {
                            columnId: 'cnOnLastPublicationFormatted', width: 100
                        },
                        {
                            columnId: 'cnOnHoldFormatted', width: 100
                        },
                        {
                            columnId: 'cnReleasedFormatted', width: 100
                        }
                    ],
                    sortBy: {
                        id: sortBy,
                        type: sortType
                    },
                    defaultOrder: columnsDefaultOrder,
                    order: columnsOrder
                }}
                onSort={handleSort}
                columnReorder
                onColumnReorder={(newOrder) => setColumnsOrder(newOrder)}
            />
            <Button
                style={{ marginTop: '15px' }}
                leadingIcon={<IconDownload />}
                appearance="primary"
                onClick={downloadReport}
                loading={downloading}
            >
                {t('download')}
            </Button>
        </div>
    );
}

export default BonusPayment;